import React from 'react';
import { Clock } from 'lucide-react';
interface AgendaItem {
  time: string;
  topic: string;
  description: string;
}
interface AgendaSlideProps {
  content: {
    items: AgendaItem[];
  };
}
export function AgendaSlide({
  content
}: AgendaSlideProps) {
  return <div className="bg-[#F5F5F5] rounded-2xl p-12" data-id="element-53">
      <h2 className="text-4xl font-bold text-[#1C1C1C] mb-12" data-id="element-54">
        Today's Agenda
      </h2>

      <div className="space-y-6" data-id="element-55">
        {content.items.map((item, index) => <div key={index} className="bg-white rounded-xl p-6 border-l-4 border-[#0FB07D] hover:shadow-lg transition-shadow" data-id="element-56">
            <div className="flex items-start gap-4" data-id="element-57">
              <div className="flex items-center gap-2 text-[#017C6D] font-semibold min-w-[100px]" data-id="element-58">
                <Clock size={18} data-id="element-59" />
                <span data-id="element-60">{item.time}</span>
              </div>
              <div className="flex-1" data-id="element-61">
                <h3 className="text-xl font-bold text-[#1C1C1C] mb-2" data-id="element-62">
                  {item.topic}
                </h3>
                <p className="text-[#4D4D4D]" data-id="element-63">{item.description}</p>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}
export default AgendaSlide;